import { useState } from 'react';
import { DropdownMenu, Icon } from '@kontentino/ui';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { useTranslation } from 'react-i18next';
import useAppLanguage from 'app/modules/translations/hooks/useAppLanguage';
import SearchTextInput from 'app/components/SearchTextInput';
import StringUtils from 'utils/string';

export const SettingsLanguageItem = () => {
  const { setLanguage, languageOptions } = useAppLanguage();
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const activeOption = languageOptions.find((option) => option.isActive);

  const filteredOptions = search
    ? languageOptions.filter((option) =>
        StringUtils.isSubstring(search, option.name),
      )
    : languageOptions;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger data-cy="settings_sidebar_language">
        <div className="tw-flex tw-h-8 tw-w-full tw-items-center tw-gap-2 tw-rounded tw-px-2 tw-py-[6px] tw-text-sm tw-font-medium tw-text-grayscale-180 hover:tw-bg-grayscale-10">
          <Icon icon={faLanguage} size="sm" className="tw-text-grayscale-100" />
          <span>{t('language')}</span>
          {activeOption && (
            <span className="tw-ml-auto tw-flex tw-items-center tw-gap-1 tw-text-grayscale-100">
              <span role="img" aria-label={activeOption.name}>
                {activeOption.flag}
              </span>
              <Icon icon={faChevronDown} size="sm" />
            </span>
          )}
        </div>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        side="right"
        align="start"
        className="tw-z-[100] tw-flex tw-h-[350px] tw-flex-col tw-overflow-hidden tw-py-0"
      >
        <div
          className="tw-shrink-0 tw-border-b tw-border-grayscale-10 tw-p-2"
          onKeyDown={(e) => e.stopPropagation()}
        >
          <SearchTextInput
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onClear={() => setSearch('')}
            autoFocus
            data-cy="settings_sidebar_language_search"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-overflow-y-auto tw-py-2">
          {filteredOptions.map((option) => (
            <DropdownMenu.Item
              key={option.key}
              selected={option.isActive}
              onClick={() => setLanguage(option.key)}
              data-cy={`settings_sidebar_language_${option.key}`}
            >
              <span
                role="img"
                aria-label={option.name}
                className="tw-leading-none"
              >
                {option.flag}
              </span>
              {option.name}
            </DropdownMenu.Item>
          ))}
          {filteredOptions.length === 0 && (
            <div className="tw-px-4 tw-py-3 tw-text-sm tw-text-grayscale-100">
              {t('noLanguagesFound')}
            </div>
          )}
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
